// Enhanced RemoveFieldConfirmationModal.js
import React from 'react';
import { Modal, Text, Button } from '@mantine/core';
import { FormattedMessage, useIntl } from 'react-intl';

const RemoveFieldConfirmationModal = ({ 
  fieldName, 
  onConfirm, 
  onCancel, 
  opened,
  message,
  confirmText,
  cancelText,
  title: customTitle
}) => {
  const intl = useIntl();

  // Determine the title based on props
  let title;
  if (customTitle) {
    // Use custom title if provided
    title = customTitle;
  } else if (fieldName && fieldName.name) {
    // Use fieldName.name if it exists (used for custom title objects)
    title = fieldName.name;
  } else {
    // Fall back to default title with SKU
    const defaultTitle = intl.formatMessage({ id: 'modal.remConfirm.title' });
    title = `${defaultTitle} ${fieldName?.sku || ''} ?`;
  }

  return (
    <Modal
      title={title}
      size="sm"
      opened={opened}
      onClose={onCancel}
      shadow="xs"
    >
      <Text style={{ margin: '10px' }}>
        {message || <FormattedMessage id="modal.remConfirm.text" />}
      </Text>
      <Button variant="light" color="blue" onClick={onCancel} style={{ margin: '10px' }}>
        {cancelText || <FormattedMessage id="button.cancel" />}
      </Button>
      <Button variant="filled" color="green" onClick={onConfirm} style={{ margin: '10px' }}>
        {confirmText || <FormattedMessage id="button.confirm" />}
      </Button>
    </Modal>
  );
};

export default RemoveFieldConfirmationModal;